<script setup lang="ts">
import { postBannerBackgroundColorTailwindClass } from '@@/bits/post_color'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import { useSurfacePostPropertiesStore } from '@@/pinia/surface_post_properties'
import type { Post } from '@@/types'
import { computed } from 'vue'

const props = defineProps<{
  post: Post
  colorScheme: 'light' | 'dark'
}>()

const surfacePostPropertiesStore = useSurfacePostPropertiesStore()
const { getDisplayedColorForPost } = surfacePostPropertiesStore

const postBannerBgColorClass = computed(() => {
  const postColor = getDisplayedColorForPost(props.post)
  return postBannerBackgroundColorTailwindClass({
    postColor,
    isLightColorScheme: props.colorScheme === 'light',
  })
})

const formattedScheduledDateTime = computed(() => {
  if (props.post.scheduled_at == null) return undefined
  return new Date(props.post.scheduled_at).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
})
</script>

<template>
  <div
    :class="[
      'scheduled-post-banner',
      'box-border',
      'h-9',
      'relative',
      'ps-3 pt-2.5',
      'rounded-ss-xl rounded-se-xl',
      postBannerBgColorClass,
    ]"
  >
    <div
      :class="[
        'flex flex-row items-center gap-x-1',
        colorScheme === 'dark' ? 'text-light-text-200' : 'text-dark-text-200',
      ]"
    >
      <OzIcon name="recent_outline" :size="16" />
      <time class="text-12-16" :datetime="post.scheduled_at">
        {{ formattedScheduledDateTime }}
      </time>
    </div>

    <!-- another div to fill in tiny gap between the banner and the post row -->
    <div :class="['absolute inset-x-0 h-2.5 -bottom-2.5', postBannerBgColorClass]" />
  </div>
</template>
